import * as React from 'react'
import { useDispatch } from 'react-redux'

import { closeModal } from 'src/modules/modal'

import Button from 'src/components/atoms/common/Button'
import Img from 'src/components/molecules/common/ResponsiveImage'

import * as styles from 'src/components/molecules/Modal/QuestionnaireRequest/Top/style.module.styl'

interface IProps {
  children?: React.ReactNode
  options?: {
    resultID?: string
    callback?: Function
  }
}

const Component: React.FC<IProps> = (props) => {
  const dispatch = useDispatch()

  const close = () => {
    dispatch(closeModal())
    props.options?.callback && props.options.callback()
  }

  return (
    <div className={styles.questionnairerequest}>
      <h2 className={styles.questionnairerequest_title}>
        <Img src="common/questionnairerequest/top_ttl_1.svg" alt="お客様アンケート実施中" />
      </h2>
      <p className={styles.questionnairerequest_lead}>
        現在こちらのサービスを利用された方へ<br />
        アンケートを実施しております。
      </p>
      <div className={styles.questionnairerequest_description}>
        <p>
          毎週50名さまへAmazonギフトカード1,000円分を<br />
          抽選でプレゼントしておりますので、<br />
          ぜひご参加ください。
        </p>
        <p>
          また、アンケートは診断完了後、<br />
          「お客様アンケートに回答する」ボタン押下後にご案内してます。<br />
          アンケートフォームへのリンクからご参加ください。
        </p>
      </div>
      <div className={styles.questionnairerequest_image}>
        <span className={styles.image}>
          <Img src="common/questionnairerequest/img_3.png" alt="こちらのボタンを押下した後にアンケートが表示されます" />
        </span>
      </div>
      <div className={styles.questionnairerequest_notice}>
        <p>※当選品お渡しにつきご回答時にはメールアドレスが必須となります。</p>
        <p>※本アンケートは、市場調査実施機関・株式会社コミュニケーション科学研究所による提供です。</p>
        <p>本アンケートについてのお問い合わせはAmazonではお受けしておりません。</p>
        <p>
          「AI診断サービス」お客様さまアンケート事務局<br />
          （株式会社コミュニケーション科学研究所）<br />
          【<a href="mailto:bs_tire-ai_service@csi-net.co.jp" target="_blank" rel="noopener noreferrer">bs_tire-ai_service@csi-net.co.jp</a>】までお願いいたします。
        </p>
        <p>
          ※Amazon、Amazon.co.jpおよびそれらのロゴは<br />
          Amazon.com, Inc. またはその関連会社の商標です。
        </p>
      </div>
      <div className={styles.questionnairerequest_buttons}>
        <ul className={styles.buttons}>
          <li className={styles.buttons_item}>
            <div className={styles.button}>
              <Button className="closeModal" handleClick={close}>
                <span className={styles.button_text}>TOPに戻る</span>
                <span className={styles.button_icon}><span><i className={'cIcon-arrow1'} /></span></span>
              </Button>
            </div>
          </li>
        </ul>
      </div>
    </div>
  )
}
export default Component
